var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 344.845,
    height: 445.27,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-134.257 -43.929)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M476.805 390.617l-170.959 98.582-170.958-98.582c-.007-33.583-.96-122.888-.511-169.311.45-46.424 2.302-49.967 7.906-54.203 20.983-20.128 98.436-27.145 125.121-25.62 22.773 1.3 35.632-15.003 46.259-34.034 24.7-44.24 34.49-63.29 80.55-63.356 8.872-.012 88.717-12.289 84.746 177.928zm-67.959-67.5h-26v49.035c0 46.4.094 48.984 1.75 48.075.963-.528 17.275-9.945 36.25-20.926l34.5-19.965c.14-52.381.326-104.762.511-157.142h-47.01v100.923zm-134 0h-26v109.616l28.006 16.192c15.403 8.906 28.438 16.192 28.967 16.192.528 0 13.575-7.271 28.994-16.158l28.033-16.158V323.117h-26V222.194h-62v100.923zm-118.755-28.89l.255 85.109 34.5 19.965c18.975 10.98 35.288 20.398 36.25 20.926 1.656.909 1.75-1.676 1.75-48.075v-49.035h-26V222.194h-47.011z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.652abfe350582847d3e2196a8b815975.svg";
export { ForwardRef as ReactComponent };